import React from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import Footer from './Footer';

export function Layout(props) {
 

    return (
        <div className="main_body vh-100 d-flex flex-column">
            <NavMenu />
            <Container className="flex-1">
                {props.children}
            </Container>
            <Footer />

        </div>
    );
  
}
